
import { useTranslate } from 'src/locales';
import { TaskPriority } from 'src/services/tasks/tasks.types';

import Label, { LabelProps } from 'src/components/label';

type Props = {
  priority: TaskPriority;
} & LabelProps;

export default function TaskPriorityLabel({ priority, sx, ...other }: Props) {
  const { t } = useTranslate();

  const getLabelColor = (val: TaskPriority) => {
    switch (val) {
      case TaskPriority.HIGH:
        return 'error';
      case TaskPriority.MEDIUM:
        return 'warning';
      case TaskPriority.LOW:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Label variant="soft" color={getLabelColor(priority)}>
      {t(`enums.task_priority.${priority}`)}
    </Label>
  );
}
